import styles from './styles.module.scss';

export interface TokenItem {
    key: any;
    value?: any;
    text: string;
    description?: string;
    title?: string;
    extras?: {};
}

interface TokenProps extends TokenItem {
    wrapperText?: string;
    wrapperDescription?: string;
    deletable?: boolean;
    onDelete?: Function;
}

export const Token = ({
    wrapperText,
    wrapperDescription,
    text,
    description,
    title,
    deletable = true,
    onDelete
}: TokenProps) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.details} title={title}>
                <div className={`${wrapperText ?? ''} ${styles.text}`}>{text}</div>
                {description && (
                    <div className={`${wrapperDescription ?? ''} ${styles.description}`}>
                        {description}
                    </div>
                )}
            </div>
            {deletable && (
                <div
                    className={`fa fa-window-close ${styles.delete}`}
                    aria-hidden='true'
                    onClick={() => onDelete && onDelete()}
                />
            )}
        </div>
    );
};
